import { ReactElement } from 'react'
import { Box, CircularProgress } from '@mui/material'

/**
 * Spinner shown in place of the delete icon. Sized like a small icon (20px) so
 * the button, and with it the tree row, keeps its height while deleting.
 */
const DeleteProgress = (): ReactElement => (
  <Box
    sx={{ width: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
  >
    <CircularProgress size={16} sx={{ color: 'inherit' }} />
  </Box>
)

export default DeleteProgress
